import { useSnackbar } from 'notistack'
import { FC, ReactNode, useEffect, useState } from 'react'

interface Props {
  children: ReactNode
}

export const ScreenSizeWarningProvider: FC<Props> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, []) // Empty dependency array means this effect runs once on mount
  useEffect(() => {
    if (windowWidth < 1440) {
      enqueueSnackbar('For a better experience, use a higher resolution display', {
        variant: 'error',
        autoHideDuration: 8000,
      })
    }
  }, [windowWidth]) // Runs when windowWidth changes

  return <>{children}</>
}
